<template>
  <modal name="insert-lots-from-outside-modal"
         @before-close="resetComponent"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Չափաբաժինների մուտքագրում դրսից</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('insert-lots-from-outside-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <div class="row">
        <div class="col-6 steps">
          <p>Ուշադրություն!</p>
          <ol>
            <li class="mb-2">
              <span class="mr-2">
                Ներբեռնեք գնման հայտի օրինակը
              </span>
              <a id="doc" href="/assets/dashboard/assets/files/lots_excel_example.xlsx">
                <i class="far fa-file-excel text-success font-30"></i>
              </a>
            </li>
            <li class="mb-2">
              <span class="mr-2">
                Ծանոթանալ CPV կոդերի ցանկին
              </span>
              <a id="doc" href="/assets/dashboard/assets/files/CPV_list.xlsx">
                <i class="far fa-file-excel text-success font-30"></i>
              </a>
            </li>
            <li class="mb-2">Լրացրեք բոլոր դաշտերը,</li>
            <li class="mb-2">Պատճենեք ձեր excel ֆայլից աղյուսակը և մուտքագրեք այստեղ</li>
            <li>Ընտրել մրցույթի ձևը</li>
          </ol>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="text-dark" for="other-requirements">Պատճենեք ձեր excel ֆայլից աղյուսակը և մուտքագրեք այստեղ</label>
            <textarea v-model="copiedExcelSheet"
                      rows="4"
                      id="other-requirements"
                      class="form-control"></textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <div class="form-group" 
            v-tooltip="selectedType
            ?
              'մեկ ընթացակարգում չի կարող լինել տարբեր գնման ձևերով չափաբաժին'
            :
              ''
            "
          >
            <label class="text-dark" for="type">Մրցույթի Ձև</label>
              <select
                :disabled="selectedType"
                v-model="type"
                name="type"
                id="type"
                :class="{'border-danger': type.$dirty && !type.required}"
                class="form-control">
                <option :disabled="key == 2" :key="key" v-for="(type, key) in purchaseTypesForItenderLongNames" :value="key">
                  {{ type }}
                </option>
              </select>
          </div>
        </div>
         <div class="col-1">
          <div v-if="+type === 2" class="form-group">
            <label class="text-dark" for="type">Քայլերը</label>
              <select
                v-model="auctionSteps"
                name="type"
                id="type"
                :class="{'border-danger': type.$dirty && !type.required}"
                class="form-control">
                <option value="0.5">0.5%</option>
                <option value="1">1%</option>
                <option value="1.5">1.5%</option>
                <option value="2">2%</option>
                <option value="2.5">2.5%</option>
                <option value="3">3%</option>
                <option value="3.5">3.5%</option>
                <option value="4">4%</option>
                <option value="4.5">4.5%</option>
                <option value="5 ">5%</option>
              </select>
          </div>
        </div>
        <!-- <div class="col-6">
          <div class="form-check">
            <input :disabled="selectedIsCondition !== false && selectedIsCondition !== 1" v-model="is_condition" value="1" class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
            <label v-tooltip="selectedIsCondition !== false && selectedIsCondition !== 1 ? 'մեկ ընթացակարգում չի կարող լինել պայմանով և առանց պայմանի չափաբաժին':''" class="form-check-label" for="flexRadioDefault1">
              Պայմանով
            </label>
          </div>
          <div class="form-check">
            <input :disabled="selectedIsCondition !== false && selectedIsCondition !== 0" v-model="is_condition" value="0" class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked>
            <label v-tooltip="selectedIsCondition !== false && selectedIsCondition !== 0 ? 'մեկ ընթացակարգում չի կարող լինել պայմանով և առանց պայմանի չափաբաժին':''" class="form-check-label" for="flexRadioDefault2">
              Առանց պայման
            </label>
          </div>
        </div> -->
      </div>
      <div class="d-flex justify-content-end">
        <button @click="convertData" :disabled="isConvertLoading" class="btn btn-primary">
          <span v-if="isConvertLoading" class="mr-1 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Արտածել
        </button>
      </div>
      <table class="table mt-4">
        <thead>
          <tr>
            <th scope="col" style="width: 70px;">Չ/Հ*</th>
            <th scope="col">Չափաբաժնի ծածկագիր * 
              <span
                @click="$modal.show('add-cpv-modal', handleAddRows)"
                style="cursor: pointer"
                class="btn-link"
              > 
                  (CPV)
              </span>
            </th>
            <th scope="col">Անվանում*</th>
            <th scope="col">Անվանում (ռուսերեն)</th>
            <th scope="col">Տեխնիկական բնութագիր* </th>
            <th scope="col">Տեխնիկական բնութագիր (ռուսերեն)</th>
            <th scope="col">Չափման միավոր*</th>
            <th scope="col">Չափման միավոր (ռուսերեն)</th>
            <th scope="col">Միավոր գին* (ՀՀ դրամ)</th>
            <th scope="col">Ընդհանուր քանակ*</th>
          </tr>
        </thead>
        <tbody v-if="tableData.length">
          <tr v-for="(row, index) in tableData" :key="index + Math.random()" :class="wrongRows.find(item=>item.cpvCode===row.cpvCode) && 'text-danger'">
            <td>
              <template v-if="row.fromExcel">
                {{ row.lotNumber }}
              </template>
              <template v-else>
                <input
                  @change="(event) => {
                    changeInputsName(index, 'lotNumber', event.target.value)
                  }"
                  :value="row.lotNumber"
                  v-mask="'###'"
                  type="text"
                  class="form-control"
                >
              </template>
            </td>
            <td>
              <template v-if="row.fromExcel">
                {{ row.cpvCode }}<span v-if="row.cpvDrop">/{{ row.cpvDrop }}</span>
              </template>
              <template v-else>
                <input
                  @change="(event) => {
                    changeInputsName(index, 'cpvCode', event.target.value)
                  }"
                  :value="row.cpvCode"
                  v-mask="'########/###'"
                  type="text"
                  class="form-control"
                >
              </template>
            </td>
            <td>
              <template v-if="row.fromExcel">
                {{ row.cpvNameArm }}
              </template>
              <template v-else>
                <input
                  @change="(event) => {
                    changeInputsName(index, 'cpvNameArm', event.target.value)
                  }"
                  :value="row.cpvNameArm"
                  type="text"
                  class="form-control"
                >
              </template>
            </td>
            <td>
              <template v-if="row.fromExcel">
                {{ row.cpvNameRu }}
              </template>
              <template v-else>
                <input
                  @change="(event) => {
                    changeInputsName(index, 'cpvNameRu', event.target.value)
                  }"
                  :value="row.cpvNameRu"
                  type="text"
                  class="form-control"
                >
              </template>
            </td>
            <td :colspan="row.cpvId ? 2 : 1">
              <template v-if="row.fromExcel">
                {{ row.specification }}
              </template>
              <template v-else>
                <button 
                  :key="specificationChangeKey"
                  v-if="row.cpvId" 
                  @click="$modal.show('specification-modal', {
                    specificationsId: row.specifications_id,
                    cpvId: row.cpvId
                  })"
                  type="button"
                  :class="{
                    'btn-success': row.specifications_id,
                    'btn-info': !row.specifications_id,
                  }"
                  class="btn btn-square btn-outline-dashed waves-effect waves-light modal03"
                >
                  <i class="fa fa-check"></i>
                </button>
                <input
                  v-else
                  @change="(event) => {
                    changeInputsName(index, 'specification', event.target.value)
                  }"
                  :value="row.specification"
                  type="text"
                  class="form-control"
                >
              </template>
            </td>
            <td v-if="!row.cpvId">
              <template v-if="row.fromExcel">
                {{ row.specificationRu }}
              </template>
              <template v-else>
                <input
                  @change="(event) => {
                    changeInputsName(index, 'specificationRu', event.target.value)
                  }"
                  :value="row.specificationRu"
                  type="text"
                  class="form-control"
                >
              </template>
            </td>
            <td>
              <template v-if="row.fromExcel">
                {{ row.unit }}
              </template>
              <template v-else>
                <input
                  @change="(event) => {
                    changeInputsName(index, 'unit', event.target.value)
                  }"
                  :value="row.unit"
                  type="text"
                  class="form-control"
                >
              </template>
            </td>
            <td>
              <template v-if="row.fromExcel">
                {{ row.unitRu }}
              </template>
              <template v-else>
                <input
                  @change="(event) => {
                    changeInputsName(index, 'unitRu', event.target.value)
                  }"
                  :value="row.unitRu"
                  type="text"
                  class="form-control"
                >
              </template>
            </td>
            <td>
              <template v-if="row.fromExcel">
                {{ row.unit_amount }}
              </template>
              <template v-else>
                <input
                  @change="(event) => {
                    changeInputsName(index, 'unit_amount', event.target.value)
                  }"
                  :value="row.unit_amount"
                  type="number"
                  class="form-control"
                >
              </template>
            </td>
            <td>
              <template v-if="row.fromExcel">
                {{ row.count }}
              </template>
              <template v-else>
                <input
                  @change="(event) => {
                    changeInputsName(index, 'count', event.target.value)
                  }"
                  :value="row.count"
                  type="number"
                  class="form-control"
                >
              </template>
            </td>
            <td>
              <div>
                <div class="row d-block">
                  <div class="col-6 mb-2">
                    <button v-if="tableData.length !== 1" @click="removeRow(index)" type="button" class="btn btn-danger">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div v-if="index === tableData.length - 1" class="col-6">
                    <button  @click="$modal.show('add-cpv-modal', handleAddRows)" 
                      type="button" class="btn btn-success"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button v-if="isAttached" @click="$modal.hide('insert-lots-from-outside-modal')" class="btn btn-sm btn-light mr-3">
        Փակել
      </button>
      <button v-if="isConverted" @click="save" type="button" class="btn btn-sm btn-primary" :disabled="isLoading">
        <span v-if="isLoading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        Պահպանել
      </button>
    </div>
    <specification-modal @close="setSpecificationId" />
  </modal>
</template>

<script>
  import purchaseTypesForItenderLongNames from '@/mixins/purchaseTypes'
  import SpecificationModal from './SpecificationModal'
  export default {
    name: 'InsertLotsFromOutsideModal',
    mixins: [purchaseTypesForItenderLongNames],
    components: {SpecificationModal},
    data() {
      return {
        specificationChangeKey: 0,
        isLoading: false,
        isAttached: false,
        isConvertLoading: false,
        copiedExcelSheet: '',
        selectedType: false,
        selectedIsCondition: false,
        auctionSteps: "0.5",
        tableData: [
          {
            lotNumber: '',
            cpvCode: '',
            cpvNameArm: '',
            cpvNameRu: '',
            specification: '',
            specificationRu: '',
            unit: '',
            unitRu: '',
            unit_amount: '',
            count: '',
            fromExcel: false
          },
        ],
        wrongRows: [],
        halfDoneRows: [],
        rowsData: [],
        is_condition: 1,
        type: 1,
      }
    },
    computed: {
      isConverted() {
        return !!this.tableData.length
      },
      currentOrganized() {
        return this.$store.getters['organizeItender/currentOrganized']
      },
    },
    methods: {
      setSpecificationId(params) {
        console.log(this.tableData)
        this.tableData.forEach(cpv => {
          if (cpv.cpvId === params.cpvId) {
            cpv.specifications_id = params.specificationId
          }
        })
        this.specificationChangeKey = this.specificationChangeKey + 1;
        console.log(this.tableData)
      },
      resetComponent() {
        Object.assign(this.$data, this.getModalInitialState())
      },
      handleAddRows(rows){
        const isEmpty = this.tableData.length === 1 && Boolean(Object.values(this.tableData[0]).filter((item, index) => index > 0 && item !== "" && item !== false).length === 0)
        if(isEmpty){
          this.tableData = [];
        }
        rows.forEach((row) => {
          const lotIndex = this.tableData[this.tableData.length - 1] ? +this.tableData[this.tableData.length - 1].lotNumber + 1 : 1;
          const rowObj = {
            cpvId: row.id,
            lotNumber: lotIndex,
            cpvCode: row.code,
            cpvNameArm: row.name,
            cpvNameRu: row.name_ru || '',
            specification: '',
            specificationRu: '',
            unit: row.unit || '',
            unitRu: row.unit_ru || '',
            unit_amount: '',
            count: '',
            fromExcel: false
          };
          this.tableData.push(rowObj)
        })
      },
      getModalInitialState(){
        return {
          isLoading: false,
          isConvertLoading: false,
          isAttached: false,
          copiedExcelSheet: '',
          selectedType: false,
          selectedIsCondition: false,
          rowsData: [],
          tableData: [
            {
              lotNumber: '',
              cpvCode: '',
              cpvNameArm: '',
              cpvNameRu: '',
              specification: '',
              specificationRu: '',
              unit: '',
              unitRu: '',
              unit_amount: '',
              count: '',
              fromExcel: false
            },
          ],
          wrongRows: [],
          halfDoneRows: [],
          is_condition: 1,
          type: 1,
        }
      },
      changeInputsName(index, colIndex, value) {
        this.tableData[index][colIndex] = value
      },
      beforeOpen(event) {
        if(event.params.length){
          this.auctionSteps = this.currentOrganized.auction_step
          this.selectedLots = event.params
          this.type = event.params[0].type
          this.is_condition = event.params[0].is_condition
          this.selectedType = event.params[0].type
          this.selectedIsCondition = event.params[0].is_condition
        }
      },
      removeRow(index){
        this.rowsData.splice(index, 1)
        this.tableData.splice(index, 1)
        this.halfDoneRows = [];
      },
      addRow(){
        this.rowsData.push({
          lotNumber: '',
          cpvCode: '',
          cpvNameArm: '',
          cpvNameRu: '',
          specification: '',
          specificationRu: '',
          unit: '',
          unitRu: '',
          unit_amount: '',
          count: '',
          fromExcel: false
        })
        this.tableData.push({
          lotNumber: '',
          cpvCode: '',
          cpvNameArm: '',
          cpvNameRu: '',
          specification: '',
          specificationRu: '',
          unit: '',
          unitRu: '',
          unit_amount: '',
          count: '',
          fromExcel: false
        })
      },
      convertData() {
        this.isConvertLoading = true;
        if(this.copiedExcelSheet.length) {
          this.$client.post('parseRowsFromExel', {
            string: this.copiedExcelSheet
          }).then(({data}) => {
            const rows = data;
            const rowModel = {
              lotNumber: '',
              cpvCode: '',
              cpvNameArm: '',
              cpvNameRu: '',
              specification: '',
              specificationRu: '',
              unit: '',
              unitRu: '',
              unit_amount: '',
              count: '',
            }

            const rowsData = []

            let isDataInvalid = false

            for(const rowString of rows) {
              if(!rowString.length) {
                continue
              }
              const columns = rowString.split(String.fromCharCode(9))
              const rowModelKeys = Object.keys(rowModel)

              if(columns.filter((col) =>col!=="").length !== rowModelKeys.length) {
                isDataInvalid = true
                break
              }
              const row = rowModelKeys.reduce((obj, key, index) => {
                obj[key] = columns[index]
                return obj
              }, {})

              const parsedCpvCode =  row.cpvCode.toString().split('/')[0];
              const parsedCpvDrop =  row.cpvCode.toString().split('/')[1];
              row.cpvCode = parsedCpvCode;
              row.cpvDrop = parsedCpvDrop;
              row.fromExcel = true;
              rowsData.push(row);
            }

            if(isDataInvalid) {
              this.tableData = []
              this.isConvertLoading = false;
              this.$notify({
                group: 'foo',
                type: 'error',
                text: 'Մուտքագրված տվյալները սխալ են'
              })
            } else {
              rowsData.sort(function (a, b) {
                if (+a.lotNumber > +b.lotNumber) {
                  return 1;
                }
                if (+a.lotNumber < +b.lotNumber) {
                  return -1;
                }
                return 0;
              });
              this.tableData = rowsData
              this.checkData();
            }
          })
          // const rows = this.copiedExcelSheet.replace(/"((?:[^"]*(?:\r\n|\n\r|\n|\r))+([^"]|"")*)"/mg, function (match, p1) {
          //    return p1
          //         .replace(/""/g, '"')
          //         .replace(/\r\n|\n\r|\n|\r/g, ' ')
          //     ;
          // }).split(/\r\n|\n\r|\n|\r/g);
          
        
        } else {
          this.isConvertLoading = false;
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Դուք չեք մուտքագրել տվյալները'
          })
        }
      },
      async checkData(){
        var rowsData=[];
        this.wrongRows=[];
        this.halfDoneRows=[];
        let existingCpvs = []
        const cpvCodesArray = this.tableData.map(item => item.cpvCode);
        await this.$client.post(`cpv/searchArray`, cpvCodesArray).then(async({data}) => {
          existingCpvs = [...data]
        })
        await this.tableData.forEach(async(tableRow) => {
          if(
            tableRow.lotNumber !== '' &&
            tableRow.cpvCode !== '' &&
            tableRow.cpvNameArm !== '' &&
            (tableRow.specification !== '' || tableRow.specifications_id) &&
            tableRow.unit !== '' &&
            tableRow.unit_amount !== '' &&
            tableRow.count !== ''
          ){
            const parsedCpvCode = tableRow.cpvCode.split('/')[0];
            const parsedCpvDrop = tableRow.cpvCode.split('/')[1] || tableRow.cpvDrop || '';
            tableRow.cpvCode = parsedCpvCode;
            tableRow.cpvDrop = parsedCpvDrop;
            tableRow.cpvNameRu = tableRow.cpvNameRu || ' ';
            tableRow.specificationRu = tableRow.specificationRu || ' ';
            tableRow.unitRu = tableRow.unitRu || ' ';
            
            const data = existingCpvs.find(cpv => +cpv.code === +parsedCpvCode)

            const obj = {
              ...tableRow, 
              cpvId: data ? data.id : 0, 
              organize_id: this.$route.params.id, 
              type: this.type, 
              is_condition: this.is_condition
            }
            await rowsData.push(obj);
            if(!data){
              this.isLoading = false;
              await this.wrongRows.push(tableRow)
            }
            this.isConvertLoading = false;
          } else {
            this.isLoading = false;
            await this.halfDoneRows.push(tableRow)
          }
        })
        this.rowsData = rowsData;
      },
      showError(){
        this.$notify({
          group: 'foo',
          type: 'error',
          title: `Կա սխալ CPV կոդ`,
          text: 'Կրկին փորձեք!'
        })
      },
      consoleLog(msg) {
        console.log(msg)
      },
      async sendSaveRequest(rowsData) {
        if(rowsData.length === this.tableData.length) {
          rowsData.sort(function (a, b) {
            if (+a.lotNumber > +b.lotNumber) {
              return 1;
            }
            if (+a.lotNumber < +b.lotNumber) {
              return -1;
            }
            return 0;
          });
          this.$client.post('organize-row-array/fromExcel', { data: rowsData }).then(({ data }) => {
              this.isLoading = false;
              if(data.status) {
                // this.$store.dispatch('organizeItender/update', {id: this.currentOrganized.id, data: {auction_step: this.auctionSteps}}).then((response) => {
                //   console.log(response)
                // })
                this.$store.dispatch('organizeItender/getRows', {organizeId: this.$route.params.id})
                this.$modal.hide('insert-lots-from-outside-modal')
              }
          })
        }
      },
      async checkWrongRows() {
        if(this.wrongRows.length){
          this.$notify({
            group: 'foo',
            type: 'error',
            title: `Կա սխալ CPV կոդ`,
            text: 'Կրկին փորձեք!'
          })
        } 
      },
      async save() {
        this.isLoading = true;
        if(this.rowsData.length === 0){
          await this.checkData();
        }
        if(this.halfDoneRows.length){
          this.isLoading = false;
          this.$notify({
            group: 'foo',
            type: 'error',
            title: `Լրացրեք չափաբաժինների բոլոր տվյալները`,
            text: 'Կրկին փորձեք!'
          })
        } else {
          if(this.rowsData.length === 0){
            await this.checkData();
          }
          setTimeout(async() => {
            await this.sendSaveRequest(this.rowsData)
          }, 1000);
        };
      }
    }
  }
</script>

<style>
  .add-cpv-modal .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    position: absolute;
    width: 60vw !important;
    height: 70vh !important;
    margin: auto;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>

<style scoped>
.steps ol {
  list-style-type: none;
  counter-reset: elementcounter;
  padding-left: 0;
}

.steps li:before {
  content: "Քայլ " counter(elementcounter) ". ";
  counter-increment: elementcounter;
  font-weight: bold;
}
</style>